// Shared interface messages for the storefront and administration.
export const messages = {
  "Choose file": "اختيار ملف",
  "Choose files": "اختيار ملفات",
  "No file selected": "لم يتم اختيار ملف",
  "Hide": "إخفاء",
  "Show": "إظهار",
  "Omani products": "منتجات عمانية",
  "Product added to cart.": "تمت إضافة المنتج إلى السلة.",
  "Network Error": "تعذّر الاتصال بالخادم",
  "Choose a valid image or video.": "اختر صورة أو فيديو صالحًا.",
  "The slide file must not exceed 80 MB.": "يجب ألا يتجاوز حجم ملف الشريحة 80 ميغابايت.",
  "Add": "إضافة",
  "Adding...": "جارٍ الإضافة...",
  "✓ Quote emailed to {0}.": "✓ تم إرسال عرض السعر إلى {0}.",
  "the client": "العميل",
  "Email could not be sent": "تعذّر إرسال البريد الإلكتروني",
  "Loading…": "جارٍ التحميل…",
  "Updated Price": "سعر محدّث",
  "Calculated based on size.": "يتم حسابه وفقًا للحجم.",
  "Easy Ordering": "طلب بسيط",
  "Select quantity then add to cart.": "اختر الكمية ثم أضف للسلة.",
  "Invoice Support": "دعم الفواتير",
  "Request an invoice at checkout.": "يمكنك طلب الفاتورة عند إتمام الشراء.",
  "Locations": "المواقع",
  "Services": "الخدمات",
  "Help & FAQ": "المساعدة والأسئلة الشائعة",
  "Returns & Exchanges": "الإرجاع والاستبدال",
  "Customer service": "خدمة العملاء",
  "About us": "من نحن",
  "Active Filters": "الفلاتر النشطة",
  "Subcategories": "الفئات الفرعية",
  "Sort": "الترتيب",
  "Change language": "تغيير اللغة",
  "Invoice {0} created. Discount {1}.": "تم إنشاء الفاتورة {0}. الخصم {1}.",
  "Invoice split automatically": "تم تقسيم الفاتورة تلقائيًا",
  "Invoice #": "فاتورة رقم",
  "Discount: -": "الخصم: -",
  "Subtotal:": "المجموع الفرعي:",
  "Total payable:": "الإجمالي المستحق:",
  "Online order": "طلب عبر الموقع",
  "Created on": "تاريخ الإنشاء",
  "Order": "الطلب",
  "Quote requested?": "هل تم طلب عرض سعر؟",
  "Thank you for your trust 💙": "شكرًا لثقتكم 💙",
  "Generated automatically": "تم الإنشاء تلقائيًا",
  "No barcode": "لا يوجد باركود",
  "Barcode {0}": "باركود {0}",
  "Copyright ©": "حقوق النشر ©",
  "Close map": "إغلاق الخريطة",
  "Close": "إغلاق",
  "Full map": "الخريطة الكاملة",
  "Close cart": "إغلاق السلة",
  "Video": "فيديو",
  "Unable to create cart": "تعذّر إنشاء السلة",
  "Unable to load cart": "تعذّر تحميل السلة",
  "Unable to add to cart": "تعذّرت الإضافة إلى السلة",
  "Unable to update item": "تعذّر تحديث المنتج",
  "Unable to remove item": "تعذّر حذف المنتج",
  "Admin": "الإدارة",
  "Administration area": "مساحة الإدارة",
  "Unable to save the theme": "تعذّر حفظ المظهر",
  "Choose an image or video for the slide": "اختر صورة أو فيديو للشريحة",
  "Unable to add the slide": "تعذّرت إضافة الشريحة",
  "Delete this slide?": "هل تريد حذف هذه الشريحة؟",
  "Appearance & theme": "المظهر والتصميم",
  "Customize the colors, logo, background and slideshow.": "خصّص الألوان والشعار والخلفية وعرض الشرائح.",
  "Site theme": "مظهر الموقع",
  "Main colors, logo and background.": "الألوان الرئيسية والشعار والخلفية.",
  "Site name": "اسم الموقع",
  "Primary color": "اللون الرئيسي",
  "Accent color": "اللون المميز",
  "Global background color": "لون الخلفية العام",
  "Show bulk quotations on product pages": "عرض طلب عرض سعر للجملة في صفحات المنتجات",
  "Logo (optional)": "الشعار (اختياري)",
  "Logo preview": "معاينة الشعار",
  "Products page background image (optional)": "صورة خلفية صفحة المنتجات (اختياري)",
  "Products background preview": "معاينة خلفية المنتجات",
  "Background preview": "معاينة الخلفية",
  "Product information": "معلومات المنتج",
  "Edit the headings and text displayed on each product page.": "عدّل العناوين والنصوص المعروضة في كل صفحة منتج.",
  "Content block": "قسم",
  "Block": "حظر",
  "Title (English)": "العنوان (بالإنجليزية)",
  "Title (Arabic)": "العنوان (بالعربية)",
  "Text (English)": "النص (بالإنجليزية)",
  "Text (Arabic)": "النص (بالعربية)",
  "Delete this block": "حذف هذا القسم",
  "+ Add a block": "+ إضافة قسم",
  "Save theme": "حفظ المظهر",
  "Home slideshow": "عرض شرائح الصفحة الرئيسية",
  "Slides displayed at the top of the Products page.": "الشرائح المعروضة في أعلى صفحة المنتجات.",
  "New slide": "شريحة جديدة",
  "Title": "العنوان",
  "Subtitle": "العنوان الفرعي",
  "Link type": "نوع الرابط",
  "Custom link": "رابط مخصص",
  "Product": "المنتج",
  "Subcategory": "الفئة الفرعية",
  "None": "لا يوجد",
  "Display order": "ترتيب العرض",
  "URL (optional)": "الرابط (اختياري)",
  "Choose a product": "اختر منتجًا",
  "Category": "الفئة",
  "Choose a category": "اختر فئة",
  "Choose a subcategory": "اختر فئة فرعية",
  "Slide image or video": "صورة أو فيديو الشريحة",
  "Active": "نشط",
  "Add slide": "إضافة شريحة",
  "Existing slides": "الشرائح الحالية",
  "Hidden": "مخفي",
  "Delete": "حذف",
  "No slides yet.": "لا توجد شرائح بعد.",
  "Returned to products from client & invoice.": "تمت العودة إلى المنتجات من صفحة العميل والفاتورة.",
  "Back to products": "العودة إلى المنتجات",
  "Product not found.": "لم يتم العثور على المنتج.",
  "Product quantity updated.": "تم تحديث كمية المنتج.",
  "Product removed from the POS cart.": "تم حذف المنتج من سلة نقطة البيع.",
  "POS cart cleared.": "تم إفراغ سلة نقطة البيع.",
  "Client is blocked.": "العميل محظور.",
  "Existing client selected.": "تم اختيار عميل مسجّل.",
  "Popup blocked. Allow popups to print.": "تم حظر النافذة المنبثقة. اسمح بالنوافذ المنبثقة للطباعة.",
  "Client name and phone number are required.": "اسم العميل ورقم الهاتف مطلوبان.",
  "The paid amount must be greater than 0 and cannot exceed the invoice total.": "يجب أن يكون المبلغ المدفوع أكبر من صفر وألا يتجاوز إجمالي الفاتورة.",
  "POS sale paid": "تم دفع عملية البيع",
  "POS invoice printed": "تمت طباعة فاتورة نقطة البيع",
  "Invoices {0} created. Discount {1}. The total was split into invoices below 950 OMR.": "تم إنشاء الفواتير {0}. الخصم {1}. تم تقسيم الإجمالي إلى فواتير تقل عن 950 ريالًا عمانيًا.",
  "POS error.": "حدث خطأ في نقطة البيع.",
  "Point of sale": "نقطة البيع",
  "Direct sale": "بيع مباشر",
  "Total": "الإجمالي",
  "Products": "المنتجات",
  "Client & invoice": "العميل والفاتورة",
  "Scan barcode": "مسح الباركود",
  "Add a product using its barcode or a variant barcode.": "أضف منتجًا باستخدام باركود المنتج أو الخيار.",
  "line(s)": "أسطر",
  "POS cart": "سلة نقطة البيع",
  "Products added": "المنتجات المضافة",
  "No products": "لا توجد منتجات",
  "Scan a barcode to begin.": "امسح باركود للبدء.",
  "Main product": "المنتج الرئيسي",
  "Clear": "إفراغ",
  "Next": "التالي",
  "Client details": "بيانات العميل",
  "product(s) -": "منتجات -",
  "Back": "رجوع",
  "Client name *": "اسم العميل *",
  "Name": "الاسم",
  "First name / second name": "الاسم الأول / الاسم الثاني",
  "First name": "الاسم الأول",
  "Phone number *": "رقم الهاتف *",
  "Email": "البريد الإلكتروني",
  "City": "المدينة",
  "Tunis": "تونس",
  "Address": "العنوان",
  "Full address": "العنوان الكامل",
  "Invoice": "الفاتورة",
  "Amount paid by client": "المبلغ المدفوع من العميل",
  "Subtotal": "المجموع الفرعي",
  "Discount": "الخصم",
  "VAT": "ضريبة القيمة المضافة",
  "Invoice total": "إجمالي الفاتورة",
  "Invoices will automatically be split into amounts below 950 OMR.": "سيتم تقسيم الفواتير تلقائيًا إلى مبالغ تقل عن 950 ريالًا عمانيًا.",
  "Print invoice": "طباعة الفاتورة",
  "Unable to load categories": "تعذّر تحميل الفئات",
  "Creation failed": "فشل الإنشاء",
  "Delete category \"{0}\"?": "هل تريد حذف الفئة «{0}»؟",
  "Deletion failed": "فشل الحذف",
  "New category name": "اسم الفئة الجديد",
  "Update failed": "فشل التحديث",
  "Image upload failed": "فشل رفع الصورة",
  "New subcategory name": "اسم الفئة الفرعية الجديد",
  "Delete subcategory \"{0}\"?": "هل تريد حذف الفئة الفرعية «{0}»؟",
  "Categories & subcategories": "الفئات والفئات الفرعية",
  "Organize your products into categories and subcategories.": "نظّم منتجاتك حسب الفئات والفئات الفرعية.",
  "Current structure": "الهيكل الحالي",
  "Rename, delete or change the image.": "غيّر الاسم أو احذف أو عدّل الصورة.",
  "🖼️ Image": "🖼️ الصورة",
  "✏️ Rename": "✏️ تغيير الاسم",
  "🗑️ Delete": "🗑️ حذف",
  "No subcategories": "لا توجد فئات فرعية",
  "No categories yet.": "لا توجد فئات بعد.",
  "Create / Add": "إنشاء / إضافة",
  "Add new categories and subcategories.": "أضف فئات وفئات فرعية جديدة.",
  "New category": "فئة جديدة",
  "Category name": "اسم الفئة",
  "e.g. Hardware": "مثال: أدوات ومعدات",
  "Upload image": "رفع صورة",
  "OR image URL (optional)": "أو رابط الصورة (اختياري)",
  "Add category": "إضافة فئة",
  "New subcategory": "فئة فرعية جديدة",
  "Parent category": "الفئة الرئيسية",
  "Subcategory name": "اسم الفئة الفرعية",
  "e.g. Locks": "مثال: أقفال",
  "Add subcategory": "إضافة فئة فرعية",
  "Unable to load clients": "تعذّر تحميل العملاء",
  "Unable to update client": "تعذّر تحديث العميل",
  "Admin – Clients": "الإدارة – العملاء",
  "View customers who placed orders and block or unblock them when needed.": "اعرض العملاء الذين قدّموا طلبات واحظرهم أو ألغِ حظرهم عند الحاجة.",
  "Clients": "العملاء",
  "Loading clients…": "جارٍ تحميل العملاء…",
  "No clients found.": "لم يتم العثور على عملاء.",
  "Phone": "الهاتف",
  "Location": "الموقع",
  "Status": "الحالة",
  "Action": "الإجراء",
  "Blocked": "محظور",
  "Unblock": "إلغاء الحظر",
  "Unable to load orders": "تعذّر تحميل الطلبات",
  "Unable to load order details": "تعذّر تحميل تفاصيل الطلب",
  "Unable to update status": "تعذّر تحديث الحالة",
  "Yes (quote requested)": "نعم (تم طلب عرض سعر)",
  "No": "لا",
  "Admin – Orders": "الإدارة – الطلبات",
  "Review incoming orders, accept or refuse them, and view their details.": "راجع الطلبات الواردة واقبلها أو ارفضها واطّلع على تفاصيلها.",
  "Orders": "الطلبات",
  "Loading orders…": "جارٍ تحميل الطلبات…",
  "No orders found.": "لم يتم العثور على طلبات.",
  "Client": "العميل",
  "Quote?": "عرض سعر؟",
  "Quote": "عرض سعر",
  "Yes": "نعم",
  "Order details": "تفاصيل الطلب",
  "Order #": "طلب رقم",
  "Close order details": "إغلاق تفاصيل الطلب",
  "Select an order to view its details.": "اختر طلبًا لعرض تفاصيله.",
  "Loading order details…": "جارٍ تحميل تفاصيل الطلب…",
  "Quote requested": "تم طلب عرض سعر",
  "Created": "تاريخ الإنشاء",
  "Total payable": "الإجمالي المستحق",
  "OMR - discount": "ريال عماني - خصم",
  "Message from client": "رسالة العميل",
  "Items": "المنتجات",
  "Variant": "الخيار",
  "Qty": "الكمية",
  "Quote unit price": "سعر الوحدة في العرض",
  "Unit price": "سعر الوحدة",
  "Quote total": "إجمالي عرض السعر",
  "Line total": "إجمالي السطر",
  "Send quote / Price offer": "إرسال عرض سعر",
  "✓ Sent": "✓ تم الإرسال",
  "Requested quantity": "الكمية المطلوبة",
  "pieces": "قطع",
  "Price per piece": "سعر القطعة",
  "To enter": "يُرجى الإدخال",
  "To calculate": "يُرجى الحساب",
  "Proposed price per piece (OMR) *": "السعر المقترح للقطعة (ريال عماني) *",
  "e.g. 10.00": "مثال: 10.00",
  "Client note": "ملاحظة العميل",
  "e.g. Free delivery included, available within 3 days...": "مثال: يشمل التوصيل المجاني، متوفر خلال 3 أيام...",
  "🎨 Design details": "🎨 تفاصيل التصميم",
  "e.g. Color #3B82F6, Roboto font, centered logo...": "مثال: اللون #3B82F6، خط Roboto، الشعار في الوسط...",
  "Sending...": "جارٍ الإرسال...",
  "♻️ Resend quote": "♻️ إعادة إرسال عرض السعر",
  "📧 Send quote": "📧 إرسال عرض السعر",
  "Refuse": "رفض",
  "Accept": "قبول",
  "Unable to load analytics": "تعذّر تحميل الإحصاءات",
  "Footer saved successfully.": "تم حفظ تذييل الصفحة بنجاح.",
  "Unable to save footer": "تعذّر حفظ تذييل الصفحة",
  "Footer": "تذييل الصفحة",
  "Design the site footer: columns, colors, fonts and social icons.": "صمّم تذييل الموقع: الأعمدة والألوان والخطوط وأيقونات التواصل الاجتماعي.",
  "Footer design": "تصميم التذييل",
  "Manage the footer independently from the rest of the theme.": "عدّل التذييل بشكل مستقل عن باقي عناصر المظهر.",
  "Enable footer": "تفعيل التذييل",
  "Layout": "التخطيط",
  "Horizontal (side-by-side columns)": "أفقي (أعمدة متجاورة)",
  "Vertical / stacked": "عمودي / متراص",
  "Mode": "النمط",
  "Columns (Solutions / Platform / Services...)": "أعمدة (حلول / منصة / خدمات...)",
  "Simple (text + location)": "بسيط (نص وموقع)",
  "Background color": "لون الخلفية",
  "Text color": "لون النص",
  "Font": "الخط",
  "Text size": "حجم النص",
  "e.g. 0.9rem, 14px": "مثال: 0.9rem، 14px",
  "Main text (basic HTML allowed)": "النص الرئيسي (يسمح باستخدام HTML بسيط)",
  "Short description, copyright, etc.": "وصف قصير، حقوق النشر، إلخ.",
  "Location / tagline": "الموقع / العبارة التعريفية",
  "Sousse – Tunisia, Paris – France...": "سوسة – تونس، باريس – فرنسا...",
  "Footer image (optional)": "صورة التذييل (اختياري)",
  "Footer image preview": "معاينة صورة التذييل",
  "Footer preview": "معاينة التذييل",
  "Facebook URL": "رابط فيسبوك",
  "X / Twitter URL": "رابط إكس / تويتر",
  "LinkedIn URL": "رابط لينكدإن",
  "Instagram URL": "رابط إنستغرام",
  "Footer columns (Solutions / Platform / Services...)": "أعمدة التذييل (حلول / منصة / خدمات...)",
  "Add a title and a list of entries to each column (one entry per line).": "أضف عنوانًا وقائمة إلى كل عمود (عنصر واحد في كل سطر).",
  "Column title": "عنوان العمود",
  "Solutions, Platform...": "حلول، منصة...",
  "Entries (one per line)": "العناصر (عنصر في كل سطر)",
  "+ Add a column": "+ إضافة عمود",
  "Save footer": "حفظ التذييل",
  "Preview": "معاينة",
  "Live preview of how the footer will appear on the site.": "معاينة مباشرة لشكل التذييل على الموقع.",
  "Footer disabled. Enable it in the form to see the preview.": "التذييل معطّل. فعّله في النموذج لعرض المعاينة.",
  "Footer visual": "صورة التذييل",
  "Login failed": "فشل تسجيل الدخول",
  "Admin Login": "تسجيل دخول الإدارة",
  "Administrator access": "دخول المشرفين",
  "Sign in to manage the catalog, orders and theme.": "سجّل الدخول لإدارة الكتالوج والطلبات والمظهر.",
  "Email address": "عنوان البريد الإلكتروني",
  "Password": "كلمة المرور",
  "Signing in...": "جارٍ تسجيل الدخول...",
  "Sign in": "تسجيل الدخول",
  "This area is reserved for store administrators.": "هذه المساحة مخصصة لمشرفي المتجر.",
  "Unable to load data": "تعذّر تحميل البيانات",
  "🛒 Abandoned carts": "🛒 السلال المتروكة",
  "Customers who added products to their cart without placing an order.": "العملاء الذين أضافوا منتجات إلى السلة دون إتمام الطلب.",
  "active carts": "سلال نشطة",
  "🔥 Most added products": "🔥 المنتجات الأكثر إضافة",
  "Loading data…": "جارٍ تحميل البيانات…",
  "No products in carts.": "لا توجد منتجات في السلال.",
  "units ·": "وحدات ·",
  "carts": "سلال",
  "Carts without orders": "سلال لم يتم طلبها",
  "Loading carts…": "جارٍ تحميل السلال…",
  "All carts have been converted to orders 🎉": "تم تحويل جميع السلال إلى طلبات 🎉",
  "Cart #": "سلة رقم",
  "Anonymous visitor": "زائر مجهول",
  "item": "منتج",
  "Loading items…": "جارٍ تحميل المنتجات…",
  "Cart is empty.": "السلة فارغة.",
  "Unable to load partners.": "تعذّر تحميل الشركاء.",
  "Delete this partner?": "هل تريد حذف هذا الشريك؟",
  "Delete failed.": "فشل الحذف.",
  "A logo image is required to create a partner.": "صورة الشعار مطلوبة لإضافة شريك.",
  "Save failed.": "فشل الحفظ.",
  "Partners": "الشركاء",
  "Manage partner logos and names displayed on the public site.": "أدِر شعارات الشركاء وأسماءهم المعروضة على الموقع.",
  "Existing partners": "الشركاء الحاليون",
  "Click a card to edit or remove it.": "اضغط على بطاقة لتعديلها أو حذفها.",
  "No name": "بدون اسم",
  "No partners yet. Add one using the form.": "لا يوجد شركاء بعد. أضف شريكًا باستخدام النموذج.",
  "Edit partner": "تعديل الشريك",
  "Add new partner": "إضافة شريك جديد",
  "Name is optional; a logo is required when creating a partner.": "الاسم اختياري؛ الشعار مطلوب عند إضافة شريك.",
  "Partner name (optional)": "اسم الشريك (اختياري)",
  "Brand, company, etc.": "علامة تجارية، شركة، إلخ.",
  "Partner logo (image)": "شعار الشريك (صورة)",
  "Live preview": "معاينة مباشرة",
  "This is how the logo will appear on the public Partners page.": "هكذا سيظهر الشعار في صفحة الشركاء على الموقع.",
  "Saving...": "جارٍ الحفظ...",
  "Creating...": "جارٍ الإنشاء...",
  "Save changes": "حفظ التغييرات",
  "Create partner": "إضافة الشريك",
  "Cancel": "إلغاء",
  "Unable to load product": "تعذّر تحميل المنتج",
  "Unable to update featured status": "تعذّر تحديث حالة المنتج المميز",
  "Unable to update stock availability": "تعذّر تحديث توفر المخزون",
  "Delete this product?": "هل تريد حذف هذا المنتج؟",
  "Unable to add warehouse": "تعذّرت إضافة المستودع",
  "Unable to add shelf": "تعذّرت إضافة الرف",
  "Unable to save VAT": "تعذّر حفظ ضريبة القيمة المضافة",
  "Unable to save minimum stock": "تعذّر حفظ الحد الأدنى للمخزون",
  "Unable to save minimum quote quantity": "تعذّر حفظ الحد الأدنى لكمية عرض السعر",
  "Permanently delete this variant?": "هل تريد حذف هذا الخيار نهائيًا؟",
  "Unable to delete variant": "تعذّر حذف الخيار",
  "Save failed": "فشل الحفظ",
  "Unable to set main image": "تعذّر تعيين الصورة الرئيسية",
  "Delete this image?": "هل تريد حذف هذه الصورة؟",
  "Unable to delete image": "تعذّر حذف الصورة",
  "Home page selection": "اختيار منتجات الصفحة الرئيسية",
  "Use the star beside a product to show or hide it on the home page.": "استخدم النجمة بجانب المنتج لإظهاره أو إخفائه في الصفحة الرئيسية.",
  "Global minimum stock alert": "التنبيه العام للحد الأدنى للمخزون",
  "At or below this quantity, the product is out of stock unless it has its own minimum.": "عند هذه الكمية أو أقل يُعتبر المنتج غير متوفر، ما لم يكن له حد أدنى خاص.",
  "Global minimum order for a quote": "الحد الأدنى العام لطلب عرض سعر",
  "0 means no global minimum. A product-specific value overrides this rule.": "الصفر يعني عدم وجود حد أدنى عام. تؤخذ القيمة الخاصة بالمنتج عند تحديدها.",
  "Remove manual best-selling selection": "إزالة الاختيار اليدوي ضمن الأكثر مبيعًا",
  "Add manual best-selling selection": "اختيار يدوي ضمن الأكثر مبيعًا",
  "Remove from home page": "إزالة من الصفحة الرئيسية",
  "Show on home page": "عرض في الصفحة الرئيسية",
  "Set 0 to use the global minimum stock alert": "أدخل صفرًا لاستخدام الحد الأدنى العام للمخزون",
  "Set 0 to use the global minimum order for a quote": "أدخل صفرًا لاستخدام الحد الأدنى العام لطلب عرض سعر",
  "e.g. 12.00": "مثال: 12.00",
  "e.g. 19.90": "مثال: 19.90",
  "e.g. 25.00": "مثال: 25.00",
  "Variant description": "وصف الخيار",
  "Variant preview": "معاينة الخيار",
  "No image": "لا توجد صورة",
  "Unable to load users": "تعذّر تحميل المستخدمين",
  "User created successfully.": "تم إنشاء المستخدم بنجاح.",
  "Unable to create user": "تعذّر إنشاء المستخدم",
  "Users": "المستخدمون",
  "Create administrator or POS accounts for the site.": "أنشئ حسابات للمشرفين أو موظفي نقطة البيع.",
  "New user": "مستخدم جديد",
  "POS accounts can only access the sales interface.": "يمكن لحسابات نقطة البيع الدخول إلى واجهة البيع فقط.",
  "POS 1": "نقطة البيع 1",
  "At least 6 characters": "6 أحرف على الأقل",
  "Role": "الدور",
  "Create user": "إنشاء مستخدم",
  "Existing accounts": "الحسابات الحالية",
  "Administrators have full access. POS accounts only see the POS page.": "المشرفون لديهم صلاحيات كاملة. حسابات نقطة البيع ترى صفحة نقطة البيع فقط.",
  "Loading users…": "جارٍ تحميل المستخدمين…",
  "No users found.": "لم يتم العثور على مستخدمين.",
  "Review the items in your cart before checkout.": "راجع منتجات السلة قبل إتمام الطلب.",
  "Out of stock": "غير متوفر",
  "Category not found.": "لم يتم العثور على الفئة.",
  "Unable to load category": "تعذّر تحميل الفئة",
  "Unable to load products.": "تعذّر تحميل المنتجات.",
  "Go Home": "العودة إلى الرئيسية",
  "Filter by subcategory": "تصفية حسب الفئة الفرعية",
  "Quick price filters": "تصفية سريعة للسعر",
  "No cart found. Please try again.": "لم يتم العثور على سلة. يُرجى المحاولة مرة أخرى.",
  "Finalize your order securely.": "أتمم طلبك بأمان.",
  "Partner values": "قيم الشراكة",
  "No description provided.": "لا يوجد وصف.",
  "Unable to start the quote request": "تعذّر بدء طلب عرض السعر",
  "Video for {0}": "فيديو {0}",
  "View media {0}": "عرض الوسائط {0}",
  "Play video": "تشغيل الفيديو",
  "View image": "عرض الصورة",
  "Loading administration securely…": "جارٍ تحميل لوحة الإدارة بأمان…",
  "Preparing your workspace.": "جارٍ تجهيز مساحة العمل.",
  "LIVE STORE DATA": "بيانات المتجر المباشرة",
  "POS invoice": "فاتورة نقطة البيع",
  "Invoice split automatically": "تم تقسيم الفاتورة تلقائيًا",
  "Invoice #": "فاتورة رقم",
  "Contact": "التواصل",
  "Price": "السعر",
  "Product / Variant": "المنتج / الخيار",
  "Product / Size": "المنتج / الحجم",
  "Order status": "حالة الطلب",
  "Date": "التاريخ",
  "Amount": "المبلغ",
  "Quantity": "الكمية",
  "Thank you for your trust.": "شكرًا لثقتكم.",
  "Pending": "قيد الانتظار",
  "Accepted": "مقبول",
  "Refused": "مرفوض",
  "All": "الكل",
  "Administrator": "مشرف"
};

// Legacy API messages also resolve to the selected language.
export const messageAliases = {
  "oman product": "Omani products",
  "service": "Services",
  "Aide & FAQ": "Help & FAQ",
  "Retours & Échanges": "Returns & Exchanges",
  "Service clientèle": "Customer service",
  "À propos de nous": "About us",
  "Impossible de sauvegarder le thème": "Unable to save the theme",
  "Veuillez choisir une image ou vidéo pour le slide": "Choose an image or video for the slide",
  "Impossible d'ajouter le slide": "Unable to add the slide",
  "Supprimer ce slide ?": "Delete this slide?",
  "Apparence & thème": "Appearance & theme",
  "Personnalisez les couleurs, le logo, le fond et le slider.": "Customize the colors, logo, background and slideshow.",
  "Thème du site": "Site theme",
  "Couleurs principales, logo et fond.": "Main colors, logo and background.",
  "Nom du site": "Site name",
  "Couleur primaire": "Primary color",
  "Couleur d'accent": "Accent color",
  "Couleur de fond globale": "Global background color",
  "Afficher le bloc « Bulk quotation » sur les fiches produit": "Show bulk quotations on product pages",
  "Logo (optionnel)": "Logo (optional)",
  "Aperçu du logo": "Logo preview",
  "Image de fond de la page Produits (optionnelle)": "Products page background image (optional)",
  "Aperçu du fond Produits": "Products background preview",
  "Informations produit": "Product information",
  "Modifiez les titres et les textes affichés sur chaque fiche produit.": "Edit the headings and text displayed on each product page.",
  "Bloc": "Content block",
  "Titre (EN)": "Title (English)",
  "Titre (AR)": "Title (Arabic)",
  "Texte (EN)": "Text (English)",
  "Texte (AR)": "Text (Arabic)",
  "Supprimer ce bloc": "Delete this block",
  "+ Ajouter un bloc": "+ Add a block",
  "Enregistrer le thème": "Save theme",
  "Slider d'accueil": "Home slideshow",
  "Images animées affichées en haut de la page Produits.": "Slides displayed at the top of the Products page.",
  "Nouveau slide": "New slide",
  "Titre": "Title",
  "Sous-titre": "Subtitle",
  "Type de lien": "Link type",
  "Lien libre": "Custom link",
  "Produit": "Product",
  "Sous-categorie": "Subcategory",
  "Aucun": "None",
  "Ordre": "Display order",
  "URL (optionnel)": "URL (optional)",
  "Choisir un produit": "Choose a product",
  "Categorie": "Category",
  "Choisir une categorie": "Choose a category",
  "Choisir une sous-categorie": "Choose a subcategory",
  "Image ou Vidéo du slide": "Slide image or video",
  "Actif": "Active",
  "Ajouter le slide": "Add slide",
  "Slides existants": "Existing slides",
  "Masqué": "Hidden",
  "Supprimer": "Delete",
  "Aucun slide pour l'instant.": "No slides yet.",
  "Retour produits depuis client & facture.": "Returned to products from client & invoice.",
  "Retour produits": "Back to products",
  "Produit introuvable.": "Product not found.",
  "Quantite produit modifiee.": "Product quantity updated.",
  "Produit supprime du panier caisse.": "Product removed from the POS cart.",
  "Panier caisse vide.": "POS cart cleared.",
  "Client bloque.": "Client is blocked.",
  "Client existant selectionne.": "Existing client selected.",
  "Popup blocked. Autorisez les popups pour imprimer.": "Popup blocked. Allow popups to print.",
  "Nom client et telephone sont obligatoires.": "Client name and phone number are required.",
  "Montant paye doit etre superieur a 0 et ne pas depasser le total facture.": "The paid amount must be greater than 0 and cannot exceed the invoice total.",
  "Vente caisse payee": "POS sale paid",
  "Facture caisse imprimee": "POS invoice printed",
  "Factures {0} creees. Remise {1}. Le total a ete divise sous 950 OMR.": "Invoices {0} created. Discount {1}. The total was split into invoices below 950 OMR.",
  "Erreur caisse.": "POS error.",
  "Caisse": "Point of sale",
  "Vente directe": "Direct sale",
  "Produits": "Products",
  "Client & facture": "Client & invoice",
  "Scanner barcode": "Scan barcode",
  "Ajout produit par barcode produit ou variante.": "Add a product using its barcode or a variant barcode.",
  "ligne(s)": "line(s)",
  "Panier caisse": "POS cart",
  "Produits ajoutes": "Products added",
  "Aucun produit": "No products",
  "Scannez un barcode pour commencer.": "Scan a barcode to begin.",
  "Produit principal": "Main product",
  "Vider": "Clear",
  "Coordonnees client": "Client details",
  "produit(s) -": "product(s) -",
  "Retour": "Back",
  "Nom client *": "Client name *",
  "Nom": "Name",
  "Prenom / nom 2": "First name / second name",
  "Prenom": "First name",
  "Telephone *": "Phone number *",
  "Ville": "City",
  "Adresse": "Address",
  "Adresse complete": "Full address",
  "Facture": "Invoice",
  "Montant paye par client": "Amount paid by client",
  "Sous-total": "Subtotal",
  "Remise": "Discount",
  "TVA": "VAT",
  "Total facture": "Invoice total",
  "Le systeme divisera automatiquement les factures sous 950 OMR.": "Invoices will automatically be split into amounts below 950 OMR.",
  "Imprimer facture": "Print invoice",
  "Erreur lors du chargement des catégories": "Unable to load categories",
  "Échec de la création": "Creation failed",
  "Supprimer la catégorie \"{0}\" ?": "Delete category \"{0}\"?",
  "Échec de la suppression": "Deletion failed",
  "Nouveau nom de catégorie": "New category name",
  "Échec de la mise à jour": "Update failed",
  "Échec upload image": "Image upload failed",
  "Nouveau nom de sous-catégorie": "New subcategory name",
  "Supprimer la sous-catégorie \"{0}\" ?": "Delete subcategory \"{0}\"?",
  "Catégories & sous-catégories": "Categories & subcategories",
  "Organisez vos produits par familles et sous-familles.": "Organize your products into categories and subcategories.",
  "Structure actuelle": "Current structure",
  "Renommez, supprimez, ou changez l’image.": "Rename, delete or change the image.",
  "✏️ Renommer": "✏️ Rename",
  "🗑️ Supprimer": "🗑️ Delete",
  "Aucune sous-catégorie": "No subcategories",
  "Aucune catégorie pour l'instant.": "No categories yet.",
  "Créer / Ajouter": "Create / Add",
  "Ajoutez de nouvelles catégories et sous-catégories.": "Add new categories and subcategories.",
  "Nouvelle catégorie": "New category",
  "Nom de la catégorie": "Category name",
  "ex : Quincaillerie": "e.g. Hardware",
  "Image (upload)": "Upload image",
  "OU Image URL (optionnel)": "OR image URL (optional)",
  "Ajouter la catégorie": "Add category",
  "Nouvelle sous-catégorie": "New subcategory",
  "Catégorie parente": "Parent category",
  "Choisir une catégorie": "Choose a category",
  "Nom de la sous-catégorie": "Subcategory name",
  "ex : Serrures": "e.g. Locks",
  "Ajouter la sous-catégorie": "Add subcategory",
  "Error loading clients": "Unable to load clients",
  "Error updating client": "Unable to update client",
  "See all customers who placed commandes and block/unblock them if necessary.": "View customers who placed orders and block or unblock them when needed.",
  "Error loading orders": "Unable to load orders",
  "Error loading order details": "Unable to load order details",
  "Error updating status": "Unable to update status",
  "Oui (devis demandé)": "Yes (quote requested)",
  "Non": "No",
  "Admin – Commandes": "Admin – Orders",
  "Review incoming orders, accept or refuse, and see order details.": "Review incoming orders, accept or refuse them, and view their details.",
  "No commandes found.": "No orders found.",
  "Devis?": "Quote?",
  "Devis": "Quote",
  "Commande #": "Order #",
  "Select an order from the list to see its details.": "Select an order to view its details.",
  "Devis requested": "Quote requested",
  "Total a payer": "Total payable",
  "OMR - remise": "OMR - discount",
  "Envoyer Devis / Offre de Prix": "Send quote / Price offer",
  "✓ Envoyé": "✓ Sent",
  "Quantité demandée": "Requested quantity",
  "pièces": "pieces",
  "Articles": "Items",
  "À renseigner": "To enter",
  "Ex: 10.00": "e.g. 10.00",
  "Note client": "Client note",
  "Ex: Livraison gratuite incluse, disponible sous 3 jours...": "e.g. Free delivery included, available within 3 days...",
  "🎨 Détails Design": "🎨 Design details",
  "Ex: Couleur #3B82F6, police Roboto, logo centré...": "e.g. Color #3B82F6, Roboto font, centered logo...",
  "Envoi en cours...": "Sending...",
  "♻️ Renvoyer le Devis": "♻️ Resend quote",
  "📧 Envoyer le Devis": "📧 Send quote",
  "Error loading analytics": "Unable to load analytics",
  "Footer sauvegardé avec succès.": "Footer saved successfully.",
  "Impossible de sauvegarder le footer": "Unable to save footer",
  "Concevez le bas de page du site : colonnes, couleurs, police, icônes sociales, etc.": "Design the site footer: columns, colors, fonts and social icons.",
  "Design du footer": "Footer design",
  "Gérez uniquement le footer, sans affecter les autres éléments du thème.": "Manage the footer independently from the rest of the theme.",
  "Activer le footer": "Enable footer",
  "Horizontal (colonnes côte à côte)": "Horizontal (side-by-side columns)",
  "Vertical / empilé": "Vertical / stacked",
  "Colonnes (Solutions / Platform / Services...)": "Columns (Solutions / Platform / Services...)",
  "Simple (texte + localisation)": "Simple (text + location)",
  "Couleur de fond": "Background color",
  "Couleur du texte": "Text color",
  "Police": "Font",
  "Taille du texte": "Text size",
  "ex: 0.9rem, 14px": "e.g. 0.9rem, 14px",
  "Texte principal (HTML simple autorisé)": "Main text (basic HTML allowed)",
  "Description courte, droits, etc.": "Short description, copyright, etc.",
  "Localisation / baseline": "Location / tagline",
  "Image du footer (optionnelle)": "Footer image (optional)",
  "Aperçu de l'image du footer": "Footer image preview",
  "Colonnes du footer (Solutions / Platform / Services...)": "Footer columns (Solutions / Platform / Services...)",
  "Dans chaque colonne, ajoutez un titre et une liste de lignes (une entrée par ligne).": "Add a title and a list of entries to each column (one entry per line).",
  "Titre de colonne": "Column title",
  "Lignes (une par ligne)": "Entries (one per line)",
  "+ Ajouter une colonne": "+ Add a column",
  "Enregistrer le footer": "Save footer",
  "Prévisualisation": "Preview",
  "Aperçu en direct du footer tel qu'il apparaîtra sur le site.": "Live preview of how the footer will appear on the site.",
  "Footer désactivé. Activez-le dans le formulaire pour voir le rendu.": "Footer disabled. Enable it in the form to see the preview.",
  "Connectez-vous pour gerer le catalogue, les commandes et le theme.": "Sign in to manage the catalog, orders and theme.",
  "Adresse e-mail": "Email address",
  "Mot de passe": "Password",
  "Connexion...": "Signing in...",
  "Se connecter": "Sign in",
  "Cet espace est reserve aux administrateurs de la boutique.": "This area is reserved for store administrators.",
  "Erreur de chargement": "Unable to load data",
  "🛒 Paniers Abandonnés": "🛒 Abandoned carts",
  "Clients ayant ajouté des produits au panier sans passer commande.": "Customers who added products to their cart without placing an order.",
  "paniers actifs": "active carts",
  "🔥 Produits les plus ajoutés": "🔥 Most added products",
  "Chargement des données…": "Loading data…",
  "Aucun produit dans les paniers.": "No products in carts.",
  "unités ·": "units ·",
  "paniers": "carts",
  "Paniers sans commande": "Carts without orders",
  "Chargement des paniers…": "Loading carts…",
  "Tous les paniers ont été convertis en commandes 🎉": "All carts have been converted to orders 🎉",
  "Panier #": "Cart #",
  "Visiteur anonyme": "Anonymous visitor",
  "article": "item",
  "Chargement des articles…": "Loading items…",
  "Panier vide.": "Cart is empty.",
  "Logo (image) is required to create a partner.": "A logo image is required to create a partner.",
  "Manage your partners logos and names displayed on the public site.": "Manage partner logos and names displayed on the public site.",
  "Click on a card to edit or remove.": "Click a card to edit or remove it.",
  "No partners yet. Add one on the right.": "No partners yet. Add one using the form.",
  "Name is optional, logo is required when creating a partner.": "Name is optional; a logo is required when creating a partner.",
  "Erreur lors du chargement des donnees": "Unable to load data",
  "Impossible de charger le produit": "Unable to load product",
  "Erreur lors de la modification du statut vedette": "Unable to update featured status",
  "Erreur lors de la modification de la rupture de stock": "Unable to update stock availability",
  "Supprimer ce produit ?": "Delete this product?",
  "Echec de la suppression": "Deletion failed",
  "Impossible d'ajouter le depot": "Unable to add warehouse",
  "Impossible d'ajouter la ligne": "Unable to add shelf",
  "Impossible d'enregistrer la TVA": "Unable to save VAT",
  "Impossible d'enregistrer le stock min": "Unable to save minimum stock",
  "Impossible d'enregistrer le minimum devis": "Unable to save minimum quote quantity",
  "Supprimer cette variante definitivement ?": "Permanently delete this variant?",
  "Echec de la suppression de la variante": "Unable to delete variant",
  "Echec de l'enregistrement": "Save failed",
  "Impossible de definir l'image principale": "Unable to set main image",
  "Supprimer cette image ?": "Delete this image?",
  "Impossible de supprimer l'image": "Unable to delete image",
  "Home Page Selection": "Home page selection",
  "Use the star beside a product to show or hide it on Home.": "Use the star beside a product to show or hide it on the home page.",
  "Global Min Stock Alert": "Global minimum stock alert",
  "At or below this quantity, the product becomes Out of Stock unless it has its own minimum.": "At or below this quantity, the product is out of stock unless it has its own minimum.",
  "Global Min Order for Quote": "Global minimum order for a quote",
  "0 = no global minimum. A product value overrides this rule.": "0 means no global minimum. A product-specific value overrides this rule.",
  "Set 0 to use the Global Min Stock Alert": "Set 0 to use the global minimum stock alert",
  "Set 0 to use the Global Min Order for Quote": "Set 0 to use the global minimum order for a quote",
  "ex: 12.00": "e.g. 12.00",
  "ex: 19.90": "e.g. 19.90",
  "ex: 25.00": "e.g. 25.00",
  "Description specifique": "Variant description",
  "Error loading users": "Unable to load users",
  "Utilisateur cree avec succes.": "User created successfully.",
  "Error creating user": "Unable to create user",
  "Utilisateurs": "Users",
  "Creer des comptes Admin ou Caisse pour le site.": "Create administrator or POS accounts for the site.",
  "Nouvel utilisateur": "New user",
  "Le role Caisse accede seulement a l'interface de vente.": "POS accounts can only access the sales interface.",
  "Caisse 1": "POS 1",
  "Minimum 6 caracteres": "At least 6 characters",
  "Creation...": "Creating...",
  "Creer utilisateur": "Create user",
  "Comptes existants": "Existing accounts",
  "Admin voit tout. Caisse voit seulement la page Caisse.": "Administrators have full access. POS accounts only see the POS page.",
  "Error loading category": "Unable to load category",
  "Impossible de charger les produits.": "Unable to load products.",
  "Prix rapides": "Quick price filters",
  "Error adding to cart": "Unable to add to cart",
  "Afficher le media {0}": "View media {0}",
  "Chargement sécurisé de l’administration…": "Loading administration securely…",
  "Préparation de votre espace de travail.": "Preparing your workspace.",
  "Facture caisse": "POS invoice",
  "Facture divisee automatiquement": "Invoice split automatically",
  "Facture #": "Invoice #",
  "Qte": "Qty",
  "Prix": "Price",
  "Produit / Variante": "Product / Variant",
  "Produit / Taille": "Product / Size",
  "État de la commande": "Order status",
  "Montant": "Amount",
  "Téléphone": "Phone",
  "Localisation": "Location",
  "Quantité": "Quantity",
  "Prix unitaire": "Unit price",
  "Merci pour votre confiance.": "Thank you for your trust.",
  "PENDING": "Pending",
  "ACCEPTED": "Accepted",
  "REFUSED": "Refused",
  "ALL": "All",
  "ADMIN": "Administrator",
  "CAISSE": "Point of sale"
};
